// extracted by css-extract-rspack-plugin
export default {"select":"src-wab-client-components-modals-ContentEditorConfigModal-module__select-wcss41","prefsTable":"src-wab-client-components-modals-ContentEditorConfigModal-module__prefsTable-xUJfIu"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"select\":\"src-wab-client-components-modals-ContentEditorConfigModal-module__select-wcss41\",\"prefsTable\":\"src-wab-client-components-modals-ContentEditorConfigModal-module__prefsTable-xUJfIu\"}";
        // 1793541991364
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  